import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { ResponsiveHeader } from "pages/_components/header";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { actions as transferActions } from "reducers/transfers";
import MepTransferSummaryBody from "./components/SummaryBody";
import MepDisclaimer from "./components/MepDisclaimer";

const MepTransferSummaryPage = () => {
    const transfers = useSelector((state) => state.transfers);
    const transferData = transfers.otherTransferData;

    return (
        <Fragment>
            <Notification scopeToShow="MepTransferSummaryPage" />
            <ResponsiveHeader id="mep.title" backLinkTo="/mep" />

            <MainContainer>
                <I18n id="mep.summary.confirm" component="h3" />
                <MepTransferSummaryBody
                    debitAccountId={transferData.debitAccount}
                    creditCbu={transferData.creditCbu}
                    transferKind={transferData.transferKind}
                    amount={transferData.amount}
                    reasonCode={transferData.reasonCode}
                    creditCuit={transferData.creditCuit}
                    nameRecipient={transferData.nameRecipient}
                    beneficiary={transferData.beneficiary}
                    frequentDestination={transferData.frequentDestination}
                    reference={transferData.reference}
                />
                <MepDisclaimer />
                <GeneralCredentialForm
                    transactionData={transferData}
                    action={transferActions.generateMepTrasnsfer}
                    idActivity="generate.mep.transfer"
                    hideIndications
                    isToken
                />
            </MainContainer>
        </Fragment>
    );
};

export default MepTransferSummaryPage;
